import {Component, forwardRef} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {ReportGenerationService} from "../../../framework/entity/report/report-generation.service";
import {AccountPaymentReceiptReportModel} from "../../reports/account-payment-receipt-report/account-payment-receipt-report.model";

/**
 * SearchAction to void account payments
 */
@Component({
    selector: "wbo-account-payment-receipt-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => AccountPaymentReceiptSearchActionComponent),
            multi: true
        },
        provideReportModel(AccountPaymentReceiptReportModel)
    ]
})
export class AccountPaymentReceiptSearchActionComponent implements SearchAction {

    constructor(private reportModel: AccountPaymentReceiptReportModel,
                private reportGenerationService: ReportGenerationService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 60;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "sales";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.account-payment.search.action.receipt";
    }

    async doAction(data: any): Promise<void> {
        this.reportModel.data.paymentId = data["paymentId"];
        this.reportModel.data.outletId = data["outletId"];
        await this.reportGenerationService.execute(this.reportModel);
    }

    isAvailable(data: any): boolean {
        return true;
    }
}
